module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9.2b7ce5f4.webp";